import { Step } from 'react-joyride';

export const conversationsTourSteps: Step[] = [
  {
    target: '[data-tour="conversations-header"]',
    content: (
      <div>
        <h4>Conversations Hub</h4>
        <p>
          This is your central hub for all customer interactions. Manage live chats, view waiting
          customers, and handle multiple conversations efficiently.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="connected-users-widget"]',
    content: (
      <div>
        <h4>Connected Users</h4>
        <p>
          See the number of customers currently connected and chatting with agents. This updates in
          real-time.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="waiting-users-widget"]',
    content: (
      <div>
        <h4>Waiting Users</h4>
        <p>
          Monitor customers in the queue waiting for an available agent. Respond to them promptly to
          improve satisfaction.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="agent-selector"]',
    content: (
      <div>
        <h4>Agent Selection</h4>
        <p>Filter conversations by agent to view specific team member's chats.</p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="connected-list"]',
    content: (
      <div>
        <h4>Connected Customers List</h4>
        <p>
          View all customers currently in conversation with agents. Customer details and chat
          history are displayed here.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="waiting-list"]',
    content: (
      <div>
        <h4>Waiting Customers Queue</h4>
        <p>
          Customers waiting for assistance appear here. Click to accept and start a conversation.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="chat-window"]',
    content: (
      <div>
        <h4>Chat Window</h4>
        <p>
          Your main conversation interface. Type messages, send files, and interact with customers
          here.
        </p>
      </div>
    ),
    placement: 'left'
  },
  {
    target: '[data-tour="customer-info"]',
    content: (
      <div>
        <h4>Customer Information</h4>
        <p>
          View customer details, previous interactions, and context to provide personalized support.
        </p>
      </div>
    ),
    placement: 'left'
  }
];
